import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { BookText, IdCard, NotepadText, Plus, Menu, LogOut, LogIn, X, Library, UsersRound, LandPlot, ScrollText, UserPlus, MessageCirclePlus, Dices } from "lucide-react";

function Dropdown({
    secondaryNavItems,
    user,
    activeLink,
    handleOnClick,
    iconName,
    secondaryIconName,
    iconSize = 25,
    buttonText = "",
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const iconMap = {
        Plus,
        NotepadText,
        BookText,
        IdCard,
        Menu,
        LogOut,
        LogIn,
        X,
        Library,
        UsersRound,
        LandPlot,
        ScrollText,
        UserPlus,
        MessageCirclePlus,
        Dices
    };

    const OpenDropdownIcon = iconMap[iconName];
    const ClosedDropdownIcon = iconMap[secondaryIconName];

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="dropdown" ref={dropdownRef}>
            <button
                type="button"
                className="button button--standard dropdown--toggle"
                onClick={toggleDropdown}
            >

                {!isOpen ? <OpenDropdownIcon className="dropdown--icon" size={iconSize} /> : <ClosedDropdownIcon className="dropdown--icon" size={iconSize} />}
                
                <span>{buttonText}</span>

            </button>

            <div className={`dropdown--menu ${isOpen ? "open" : ""}`}>
                {secondaryNavItems.map((item, index) => {
                    if (item.authReq && !user) return null;

                    const ItemIcon = item.icon ? iconMap[item.icon] : null;

                    return (
                        <div
                            key={item.text}
                            className={`dropdown--item ${activeLink === index ? "active" : ""
                                } ${item.extraClass || ""}`}
                        >
                            {ItemIcon && <ItemIcon className="dropdown--icon" size={18} />}

                            {item.onAction ? (
                                <button
                                    className="dropdown--action-btn"
                                    onClick={() => {
                                        handleOnClick(index);
                                        closeDropdown();
                                        item.onAction();
                                    }}
                                >
                                    <span>{item.text}</span>
                                </button>
                            ) : (
                                <Link
                                    to={item.to}
                                    onClick={() => {
                                        handleOnClick(index);
                                        closeDropdown();
                                    }}
                                >
                                    <span>{item.text}</span>
                                </Link>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Dropdown;